/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../ExtensionBaseController',
	'./ForecastDetailsView',
	'./Result',
	'../../dataSources/nls/StringResources'
], function(BaseController, ForecastDetailsView, Result, StringResources) {
	'use strict';

	class ForecastDetailsController extends BaseController {

		constructor(dashboard) {
			super(dashboard);
			this.tabName = StringResources.get('forecastDetailsTabName');
			this.prefix_ID = 'fd_';
			this.view = new ForecastDetailsView({});
		}

		/**
		 * @see ExtensionBaseController
		 */
		getTabContrib() {
			const content = this._getSelectedContent();
			if(!content){
				return Promise.resolve(null);
			}

			const forecastFeature = content.getFeature('Forecast');
			if(!this._isThereForecastContribution(forecastFeature)){
				return Promise.resolve(null);
			}

			const forecastQueryResult = forecastFeature.getQueryResult();
			// Check if there is a valid Forecast details in the response
			const statisticalDetailsResponse = forecastQueryResult ? forecastQueryResult.getStatisticalDetails() : null;
			if (!statisticalDetailsResponse || statisticalDetailsResponse.length <= 0) {
				return Promise.resolve(null);
			}

			const id = content.getId();
			const tabID =  this.prefix_ID + id;
			let forceRender = false;
			return Promise.resolve([{
				id: tabID,
				name: this.tabName,
				isSelectedOnTrayRender: false,
				select: this.select.bind(this, { forecastQueryResult, id: tabID, forceRender })
			}]);
		}

		_isThereForecastContribution(forecastFeature) {
			return (forecastFeature && forecastFeature.getForecastDisplayState().toggleEnabled &&
				forecastFeature.areThereValidForecastSettings() & forecastFeature.supportsForecasts());
		}

		/**
		 * @see ExtensionBaseController
		 */
		select(context, currentTabId, container) {
			if (currentTabId === context.id && !context.forceRender) {
				return Promise.resolve(false);
			}

			const resultTable = new Result(context.forecastQueryResult);
			return this.view.render(container, resultTable);
		}
	}

	return ForecastDetailsController;
});
